import {React} from 'common'
import {useI18n} from 'store/Store'
import {FormActionButton, FormErrorMessage} from 'components/Control/Form'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {styled} from '@mui/material'
import {useDeviceDetect} from 'services/hooks'
import Button from 'components/Control/Button'
import {Colors, Texts} from 'appearance'

const SmsVerificationSection = ({
    isLoadingVerifySms,
    isLoadingLogin,
    onVerifySms,
    control,
    errors,
    handleSendSms,
    verifySmsErrorMessage,
    timeStr,
}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    return (
        <Container isMobile={isMobile}>
            <FormTextInput
                name="sms"
                label={i18n.t('register.verificationCode')}
                control={control}
                fullWidth
                type="number"
                initialValue=""
                errors={errors}
                height="48px"
                style={{color: '#95969A'}}
                InputProps={{
                    style: {background: '#FAFAFA'},
                }}
            />

            <TimerText>
                {i18n.t('login.codeWillArrive', {time: timeStr})}
            </TimerText>

            <ActionButton
                // color="secondary"
                onClick={handleSendSms}
                style={{color: Colors.LINK_TEXT}}>
                {i18n.t('register.resend')}
            </ActionButton>

            <FormActionButton
                loading={isLoadingLogin || isLoadingVerifySms}
                color="secondary"
                onClick={onVerifySms}
                variant="contained"
                height={50}>
                {i18n.t('users.enter')}
            </FormActionButton>
            <FormErrorMessage errorMessage={verifySmsErrorMessage} />
        </Container>
    )
}

export default SmsVerificationSection

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-inline: auto;
    width: ${({isMobile}) => (isMobile ? 100 : 40)}%;
    margin-top: 90px;
`

const ActionButton = styled(Button)`
    margin-bottom: 24px;
`

const TimerText = styled(Texts.RegularText)`
    margin-top: 14px;
    margin-bottom: 14px;
    text-align: center;
`
